<template>
  <SoContainer>
    <h4 class="mb-4">Fuel Estimates</h4>
    <SoRadioCards v-model="tariffQuoter.selectedFuels" multiple>
      <SoRow>
        <SoCol :default-width="6">
          <MPXNEstimationRadioCard
            is-electricity
            data-testid="tq-elec-selector"
          />
        </SoCol>
        <SoCol :default-width="6">
          <MPXNEstimationRadioCard data-testid="tq-gas-selector" />
        </SoCol>
      </SoRow>
    </SoRadioCards>
  </SoContainer>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import { useTariffQuoter } from "@/stores/tariffQuoter"
  import MPXNEstimationRadioCard from "../components/MPXNEstimationRadioCard.vue"
  import SoContainer from "@/components/SoContainer.vue"
  import SoRow from "@/components/SoRow.vue"
  import SoCol from "@/components/SoCol.vue"
  import SoRadioCards from "@/components/SoRadioCards.vue"

  export default defineComponent({
    components: {
      MPXNEstimationRadioCard,
      SoContainer,
      SoRow,
      SoCol,
      SoRadioCards,
    },
    data() {
      return {
        tariffQuoter: useTariffQuoter(),
      }
    },
  })
</script>
